<template>
  <div class="isMember">
    <div class="flex space-between">
      <div class="member-header">
        <div class="header-box">
          <el-input
            placeholder="请输入会员手机号/姓名/备注"
            v-model="memberMsg"
            @focus="handleFocus"
            @blur="hideBox"
            clearable
            @clear="clearMember"
            maxlength="18"
            prefix-icon="el-icon-search"
          />
        </div>
      </div>
      <div class="member-box" v-if="focusHide && historyMobileList.length > 0">
        <div class="p10 history-box">
          <p>历史记录</p>
          <div v-for="(item,index) in historyMobileList" :key="index">
            <!-- <el-button
              class="mt10 history-btn"
              @click="handleHistory(item)"
            >{{ item }}</el-button> -->
            <div class="not-btn">
              <el-button :key="index" class="mt10 history-btn" @click="handleHistory(item)">{{ item }}</el-button>
              <span
                @click="removeShopBox(index,item)"
                class="close-button el-icon-circle-close"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" :value="memberMsg" @change="editChange"></edit-set>
    <yuan-jian ref="yuanJianForm" @change="yuanJianChange"></yuan-jian>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import editSet from "../member/edit.vue";
import yuanJian from "./yuanjian.vue"
export default {
  mixins: [minxin],
  components: { editSet , yuanJian},
  props: {
    mobile: {
      type: String,
      default: null
    },
    pageName: {
      type: String,
      default: null
    },
    integral: {
      type: Boolean,
      default: null
    },
  },
  data() {
    return {
      dialogVisible: false,
      codeName: true,
      memberHide: false, //false
      inputHide: true,
      memberMsg: "",
      list: [],
      headImg: require("../../assets/images/headerImg.png"),
      headImgs: require("../../assets/images/new/searchMore.png"),
      focusHide: false,
      historyMobileList: [],
      listRow: {}
    };
  },
  created() {
    if (this.mobile) {
      this.memberMsg = this.mobile;
      this.selectMember();
      // this.clickMember(this.list);
    }
  },
  watch: {
    mobile (o) {
      if (o) {
        this.memberMsg = this.mobile;
        this.selectMember();
        // this.clickMember(this.list);
      }
    }
  },
  methods: {
    addClick() {
        // 注册会员
        this.$refs["editSetForm"].$emit("set", null)
    },
    editChange(bool) {
      if (bool) {
        this.selectMember();
      }
    },
    handleFocus(value) {
        this.memberHide = false;
        let arr = JSON.parse(localStorage.getItem("historyMobileList"));
        console.log('数据：',arr);
        if (arr) {
          this.historyMobileList = arr;
        }
        this.focusHide = true;
    },
    hideBox() {
      if (this.memberMsg) {
        this.$emit("handleChange", this.memberMsg);
        this.$store.commit("setMemberMobile", this.memberMsg);
      }
      
      // setTimeout(() => {
      //   this.focusHide = false;
      // }, 300);
    },
    removeShopBox(index, value) {
      let arr = [];
      if (JSON.parse(localStorage.getItem("historyMobileList"))) {
          arr = JSON.parse(localStorage.getItem("historyMobileList"));
      }
      arr.splice(index, 1);
      localStorage.setItem("historyMobileList", JSON.stringify(arr));
      this.historyMobileList = arr;
      if (this.historyMobileList.length > 0) {
        this.focusHide = true;
      }else {
        this.focusHide = false;
      }
    },
    handleHistory(msg) {
      this.focusHide = false;
      this.memberMsg = msg;
      this.$emit("handleChange", msg);
    },
    handleInputHide() {
      this.memberHide = false;
      this.inputHide = true;
      this.memberMsg = "";
      this.list = {};
      this.$store.commit("setMemberMobile", null);
      this.$emit("handleChange", "");
      this.$emit("handleUser", "");
    },
    clickMember(list) {
      this.memberHide = false;
      this.inputHide = false;
      console.log(list)
      if (this.memberMsg) {
        this.$store.commit("setMemberMobile", this.memberMsg);
      }
      this.listRow = list;
      
      this.$emit("handleChange", list.id);
      this.$emit("handleUser", list);
    },
    clearMember() {
      this.memberHide = false;
      this.focusHide = false;
      this.inputHide = true;
      this.memberMsg = ""
      this.list = {};
      this.$store.commit("setMemberMobile", null);
      this.$emit("handleChange", "");
    },
    selectMember() {
      console.log(1);
      if (this.memberMsg) {
        this.$api
          .get(this.$url.member.search, {
            keyword: this.memberMsg,
            needIntegralFlag: this.integral ? true : false
          })
          .then(res => {
            if (res) {
              this.list = res;
              this.memberHide = true;
              // this.$emit('handleChange',this.list.id);
            } else {
              this.list = res;
              this.memberHide = true;
            }
          })
          .catch(error => {});
      } else {
        this.$message.warning("请输入客户手机号");
      }
    },
    swivelClamp (row) {
      // 转卡
      let obj = {
        cardList: row,
        form: this.list
      }
      this.$refs["yuanJianForm"].$emit("open", obj)
    },
    yuanJianChange (org) {
      if (org) {
        this.selectMember();
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.isMember {
  position: relative;
  width: 100%;
  border-radius: 10px;
  // background: #fff;
}
.member-header {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 10px;
  .header-box {
    width: 100%;
    display: flex;
    box-sizing: border-box;
  }
  .search-button {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    font-size: 14px;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
    background: #3388FF;
  }
  /deep/ .el-input__inner {
    height: 40px;
  }
}
.ptb10 {
  padding: 10px;
}
.member-box {
  width: 100%;
  position: absolute;
  top: 55px;
  left: 0;
  z-index: 99;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 20px 0px rgba(31,47,67,0.2000);
  box-sizing: border-box;
  .no-result {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #646566;
    height: 120px;
    p {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .bind-member-active {
      margin-left: 5px;
      margin-top: 10px;
      color: #409eff;
      cursor: pointer;
    }
  }
  .history-box {
    padding: 10px;
  }
  .history-btn {
    margin-top: 10px;
  }

  .not-btn {
    position: relative;
    display: inline-block;
    /deep/ .el-button.is-disabled {
      background: #fff;
      border-color: #c6e2ff;
      color: #409eff;
    }
  }
  .close-button {
    position: absolute;
    right: -10px;
    top: 0px;
    color: #999;
    font-size: 20px;
    cursor: pointer;
  }
}
.list {
  .isYuanjian {
    padding: 10px;
    margin: 0 10px 10px;
    border: 1px solid #EEE;
    border-radius: 8px;
  }
  .flex-row {
    cursor: pointer;
    display: flex;
    align-items: center;
    
    
    .msg {
      margin-left: 10px;
    }
    &:hover {
      background-color: #F3F8FE;
    }
    
  }
  .member-box-yuanjian {
    display: flex;
    flex-wrap: wrap;
    margin: 5px 10px 0 50px;
    border-top: 1px solid #eee;
    padding-top: 10px;
    font-size: 14px;
    color: #666;
    .member-box-yuanjian-list {
      width: calc(50% - 20px);
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;
      .point {
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #EEE;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }
}
.member_bg {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  border-radius: 10px;
  .flex-row {
    align-items: center;
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
    }
  }
  .icons {
    margin-right: 10px;
    font-size: 18px;
    cursor: pointer;
    &:hover {
      color: @blue;
    }
  }
}
.flex {
  display: flex;
}
.toggleMember {
  width: 99px;
  height: 33px;
  text-align: center;
  line-height: 33px;
  font-size: 14px;
  color: #3388FF;
  background: #FFF;
  border: 1px solid #EEE;
  border-radius: 18px;
  .toggleMember-img {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 4px;
    img {
      margin-top: -1px;
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
}
.member-auto {
  min-height: 1px;
  max-height: 600px;
  overflow: auto;
}
</style>